// extracted by mini-css-extract-plugin
export default {"iframeContainer":"pixiContainer_iframeContainer__jLn42"};